import React, { Component } from "react";
import { compose } from "redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui";

import green from "material-ui/colors/green";
import Messages from "../constants/messages";
import withStyles from "material-ui/styles/withStyles";

const styles = theme => ({
  root: {
    float: "right",
    marginBottom: 15
  },
  btn: {
    textAlign: "right"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    right: "-0.5em",
    bottom: "0.3em",
    overflow: "hidden"
  },
  confirmCheck: {
    color: green[500],
    "&:after": {
      content: "' \u2714'"
    }
  },
  dialogActions: {
    position: "relative"
  },
  portalContainer: {
    overflow: "scroll"
  },
  svg: {
    height: "24px",
    width: "24px"
  }
});

class ShowAdminsDialog extends Component {
  
  renderDialog() {
    const { showAdminsDialog, open, admins } = this.props;
    return (
      <Dialog
        id="showAdminsDialog"
        open={open}
        onRequestClose={() => {
          showAdminsDialog(false);
        }}
        fullWidth={true}
        maxWidth = {'md'}
      >
        <DialogTitle>{Messages["uiComponents"]["ADMIN_LIST_TITLE"]}</DialogTitle>
        <DialogContent>
          <Table size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{Messages["uiComponents"]["NAME_LABEL"]}</TableCell>
                <TableCell>{Messages["uiComponents"]["ADMIN_LIST_EMAIL"]}</TableCell>
                <TableCell>{Messages["uiComponents"]["TABLE_PARTNER_NAME_COLUMN"]}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {admins &&
                admins.map(admin => (
                  <TableRow key={admin.id}>
                    <TableCell scope="row">{admin.firstName + ' ' + admin.lastName}</TableCell>
                    <TableCell>{admin.email}</TableCell>
                    <TableCell>{admin.partners && admin.partners.map(partner => partner.name).join(', ')}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            data-test-id="closeBtn"
            color="primary"
            onClick={() => {
              showAdminsDialog(false);
            }}
          >
            {Messages["uiComponents"]["ADMIN_DIALOG_CLOSE_BUTTON_LABEL"]}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { classes } = this.props;
    return <div className={classes.root}>{this.renderDialog()}</div>;
  }
}

export default compose(
  withStyles(styles)
)(ShowAdminsDialog);
